<template>
  <v-container id="orcamento" fill-height fluid grid-list-xl tag="section">
    <v-layout justify-center wrap>
      <v-flex xs12 md12 sm12>
        <div class="text-center ma-2">
          <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout" top>
            {{ textSnackbar }}
            <v-btn class="mx-2" fab small color="white" text @click="snackbar = false" dark>
              <v-icon dark>mdi-close-thick</v-icon>
            </v-btn>
          </v-snackbar>
        </div>
        <v-card>
          <div>
            <v-dialog v-model="loading" hide-overlay persistent width="300">
              <v-card color="primary" dark>
                <v-card-text>
                  Buscando informações, aguarde ...
                  <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
          <filtro-orcamento />
          <v-card color="grey lighten-5">
            <v-card-title>Orçamento</v-card-title>
          </v-card>
          <v-form>
            <v-container>
              <v-row dense>
                <v-col cols="12" md="2" sm="1" xs="1">
                  <v-text-field v-model="textOrcamentoConcat" label="Loja/Orçamento/Serie"></v-text-field>
                </v-col>
                <v-col cols="12" md="3" sm="2" xs="2">
                  <v-text-field v-model="orcamento[0].dtcad" label="Emissão"></v-text-field>
                </v-col>
                <v-col cols="12" md="4" sm="4" xs="4">
                  <v-text-field v-model="textFuncionario" label="Funcionário"></v-text-field>
                </v-col>
                <v-col cols="12" md="3" sm="3" xs="3">
                  <v-text-field v-model="textCanalCaptacao" label="Canal Captação"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" md="5" sm="5" xs="5">
                  <v-text-field v-model=" textCliente" label="Cliente"></v-text-field>
                </v-col>
                <v-col cols="12" md="2" sm="2" xs="2">
                  <v-text-field v-model="textClasse" label="Classe"></v-text-field>
                </v-col>
                <v-col cols="12" md="5" sm="5" xs="5">
                  <v-text-field v-model="textProfissional" label="Profissional"></v-text-field>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="12" md="4" sm="1" xs="1">
                  <v-text-field v-model="textForma" label="Forma / Volume"></v-text-field>
                </v-col>
                <v-col cols="12" md="1" sm="1" xs="1">
                  <v-text-field class="font-weight-bold" v-model="textCompra" label="Compra"></v-text-field>
                </v-col>
                <v-col cols="12" md="1" sm="1" xs="1">
                  <v-text-field class="font-weight-bold" v-model="textCusto" label="Custo"></v-text-field>
                </v-col>
                <v-col cols="12" md="1" sm="1" xs="1">
                  <v-text-field class="font-weight-bold" v-model="textFator" label="Fator"></v-text-field>
                </v-col>
                <v-col cols="12" md="1" sm="1" xs="1">
                  <v-text-field class="font-weight-bold" v-model="textPercTaxa" label="% Taxa"></v-text-field>
                </v-col>
                <v-col cols="12" md="1" sm="1" xs="1">
                  <v-text-field class="font-weight-bold" v-model="textTaxa" label="Taxa"></v-text-field>
                </v-col>
                <v-col cols="12" md="1" sm="1" xs="1">
                  <v-text-field class="font-weight-bold" v-model="textPercDesc" label="% Desc."></v-text-field>
                </v-col>
                <v-col cols="12" md="1" sm="1" xs="1">
                  <v-text-field class="font-weight-bold" v-model="textDesc" label="Desc."></v-text-field>
                </v-col>
                <v-col cols="12" md="1" sm="1" xs="1">
                  <v-text-field class="font-weight-bold" v-model="textVenda" label="Venda"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <v-divider></v-divider>
          <v-simple-table dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Tp</th>
                  <th class="text-left">Codigo</th>
                  <th class="text-left">Produto</th>
                  <th class="text-left">Qsp</th>
                  <th class="text-right">Qt-U</th>
                  <th class="text-center">Un</th>
                  <th class="text-right">Qt-T</th>
                  <th class="text-center">Compra</th>
                  <th class="text-center">Custo</th>
                  <th class="text-center">Fator</th>
                  <th class="text-center">Venda</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in itensOrcamento" :key="item.itemid">
                  <td>{{item.tpcmp}}</td>
                  <td>{{item.cdprin}}</td>
                  <td>{{item.descrprd}}</td>
                  <td>{{item.indqsp}}</td>
                  <td class="text-right">{{item.quant}}</td>
                  <td class="text-right">{{item.unida}}</td>
                  <td class="text-right">{{item.qtreal}}</td>
                  <td class="text-right">{{item.prcompra | dinheiro}}</td>
                  <td class="text-right">{{item.prcusto | dinheiro}}</td>
                  <td class="text-right">{{item.fator}}</td>
                  <td class="text-right">{{item.vrvenda | dinheiro}}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import FiltroOrcamento from "../components/filtros/FiltroOrcamento";

export default {
  components: {
    FiltroOrcamento
  },
  data: () => ({
    orcamento: [
      {
        cdfil: null,
        nrorc: null,
        serieo: null,
        cdfunre: null,
        nomefun: null,
        cdcaptacao: null,
        canal: null,
        cdcli: null,
        nomecli: null,
        pfcrm: null,
        classeCrm: null,
        nrcrm: null,
        ufcrm: null,
        nomemed: null,
        tpformafarma: null,
        forma_farmaceutica: null,
        univol: null,
        prcompra: null,
        prcusto: null,
        fator: null,
        pttxt: null,
        vrtxa: null,
        ptdsc: null,
        vrdec: null,
        prreal: null,
        prvenda: null,
        fatorV: null
      }
    ],
    itensOrcamento: [],
    loading: false,
    errored: false,
    snackbar: false,
    textSnackbar: "",
    snackbarColor: "",
    timeout: 10000
  }),
  mounted() {
    if (this.filtroOrcamentoStore.length) {
      this.loading = true;
      this.buscarOrcamentoViaLista();
    }
  },
  computed: {
    ...mapGetters({
      filtroOrcamentoStore: "filtroOrcamento"
    }),
    textOrcamentoConcat: {
      get() {
        if (this.orcamento[0].cdfil != null) {
          return `${this.orcamento[0].cdfil} - ${this.orcamento[0].nrorc} - ${this.orcamento[0].serieo}`;
        } else {
          return "";
        }
      }
    },
    textFuncionario: {
      get() {
        if (this.orcamento[0].cdfunre != null) {
          return `${this.orcamento[0].cdfunre} - ${this.orcamento[0].nomefun}`;
        } else {
          return "";
        }
      }
    },
    textCanalCaptacao: {
      get() {
        if (this.orcamento[0].cdcaptacao != null) {
          return `${this.orcamento[0].cdcaptacao} - ${this.orcamento[0].canal}`;
        } else {
          return "";
        }
      }
    },
    textCliente: {
      get() {
        if (this.orcamento[0].cdcli != null) {
          return `${this.orcamento[0].cdcli} - ${this.orcamento[0].nomecli}`;
        } else {
          return "";
        }
      }
    },
    textClasse: {
      get() {
        if (this.orcamento[0].pfcrm != null) {
          return `${this.orcamento[0].pfcrm} - ${this.orcamento[0].classeCrm}`;
        } else {
          return "";
        }
      }
    },
    textProfissional: {
      get() {
        if (this.orcamento[0].pfcrm != null) {
          return `${this.orcamento[0].nrcrm}/${this.orcamento[0].ufcrm} - ${this.orcamento[0].nomemed}`;
        } else {
          return "";
        }
      }
    },
    textForma: {
      get() {
        if (this.orcamento[0].tpformafarma != null) {
          return `${this.orcamento[0].tpformafarma} - ${this.orcamento[0].forma_farmaceutica} - ${this.orcamento[0].univol}`;
        } else {
          return "";
        }
      }
    },
    textCompra: {
      get() {
        if (this.orcamento[0].prcompra != null) {
          return `${parseFloat(this.orcamento[0].prcompra).toFixed(2)}`.replace(
            ".",
            ","
          );
        } else {
          return "";
        }
      }
    },
    textCusto: {
      get() {
        if (this.orcamento[0].prcusto != null) {
          return `${parseFloat(this.orcamento[0].prcusto).toFixed(2)}`.replace(
            ".",
            ","
          );
        } else {
          return "";
        }
      }
    },
    textFator: {
      get() {
        if (this.orcamento[0].fatorV) {
          return `${parseFloat(this.orcamento[0].fatorV).toFixed(2)}`;
        } else {
          return "";
        }
      }
    },
    textPercTaxa: {
      get() {
        if (this.orcamento[0].pttxa != null) {
          return `% ${parseFloat(this.orcamento[0].pttxa).toFixed(2)}`;
        } else {
          return "";
        }
      }
    },
    textTaxa: {
      get() {
        if (this.orcamento[0].vrtxa) {
          return `${parseFloat(this.orcamento[0].vrtxa).toFixed(2)}`.replace(
            ".",
            ","
          );
        } else {
          return "";
        }
      }
    },
    textPercDesc: {
      get() {
        if (this.orcamento[0].ptdsc) {
          return `% ${parseFloat(this.orcamento[0].ptdsc).toFixed(2)}`;
        } else {
          return "";
        }
      }
    },
    textDesc: {
      get() {
        if (this.orcamento[0].vrdsc != null) {
          return `${parseFloat(this.orcamento[0].vrdsc).toFixed(2)}`.replace(
            ".",
            ","
          );
        } else {
          return "";
        }
      }
    },
    textVenda: {
      get() {
        if (this.orcamento[0].prvenda != null) {
          return `${parseFloat(this.orcamento[0].prvenda).toFixed(2)}`.replace(
            ".",
            ","
          );
        } else {
          return "";
        }
      }
    }
  },
  watch: {
    filtroOrcamentoStore: function() {
      this.loading = true;
      this.buscarOrcamentoViaLista();
    }
  },
  methods: {
    listarOrcamento() {
      this.$http
        .get("orcamento", {
          params: {
            loja: this.filtroOrcamentoStore[0],
            orcamento: this.filtroOrcamentoStore[1],
            serie: this.filtroOrcamentoStore[2]
          }
        })
        .then(res => {
          this.itensOrcamento = res.data.itensOrcamento;
          this.orcamento = res.data.orcamento;
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status === 400) {
              this.textSnackbar = error.response.data[0].message;
              this.snackbar = true;
              this.snackbarColor = "error";
            }
          }
        })
        .finally(() => (this.loading = false));
    },
    buscarOrcamentoViaLista() {
      this.$http
        .get("orcamento", {
          params: {
            loja: this.filtroOrcamentoStore[0],
            orcamento: this.filtroOrcamentoStore[1],
            serie: this.filtroOrcamentoStore[2]
          }
        })
        .then(res => {
          this.itensOrcamento = res.data.itensOrcamento;
          this.orcamento = res.data.orcamento;
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status === 400) {
              this.textSnackbar = error.response.data[0].message;
              this.snackbar = true;
              this.snackbarColor = "error";
            }
          }
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>

<style>
</style>